<template>
  <div >
    <component v-for="(item,index) of datiobject.data" v-bind:key="index" :is="datiobject['zujianname'][index]" :allindex="allindex" :duanindex="index" :content="item" :singleanswerlist="datiobject['answerlist'][index]" :kaoshenganswerlistsingle="datiobject['kaoshenganswer'][index]" :fontsize="fontsize">{{item}}</component>
    <!--duanluo v-for="(item,index) of datiobject.data" v-bind:key="index+'d'">{{item}}</duanluo -->
  </div>
</template>

<script>
import duanluo from './duanluo.vue'
import tiankongcomps from './tiankongcomps.vue'
import tu from './tu.vue'
import xuanzebuttons from './xuanzebuttons.vue'
import onetext from './onetext.vue'
import panduanbuttons from './panduanbuttons.vue'
export default {
  components: { duanluo, tiankongcomps, tu, xuanzebuttons, onetext, panduanbuttons },
  props: ['datiobject', 'allindex', 'fontsize'],
  watch: {
    fontsize: function () {
      // alert(global.fontsize)
      this.$forceUpdate()
    }
  },
  data () {
    return {
      //  textdataqian: this.datiobject.zujianname // datiobject.zujianname[index]要加
    }
  }

}
</script>
